<template>
  <div class="fill-wrapper">
    <ul class="fill-header ">
      <li class="title">
        <span class="item-unit">{{this.dataValForm.projectname+'排水许可证'}}</span>
      </li>
      <li class="buttons">
        <span class="item-unit">{{'发证状态:'+(this.dataValForm.licensestate==5?'已发证':'未发证')}}</span>
      </li>

    </ul>
    <div class="content-wrapper" ref='wrapper'>
      <div style="height:100%; ">
        <el-scrollbar style="height:100%" :native="false" :noresize="false">
          <el-form :inline="true" :model="dataValForm" ref="dataValForm" :rules="rules" label-width="100px">
            <ul class="formList">
              <li class="form-item">
                <el-form-item label="单位名称" prop="companyname">
                  <el-input :disabled="true" type="input" v-model="dataValForm.companyname"></el-input>
                </el-form-item>
                <el-form-item label="项目名称" prop="projectname">
                  <el-input :disabled="true" type="input" v-model="dataValForm.projectname"></el-input>
                </el-form-item>
                <el-form-item label="项目地址" prop="projectaddre">
                  <el-input :disabled="true" type="input" v-model="dataValForm.projectaddre"></el-input>
                </el-form-item>
                <el-form-item prop="basearea" label="占地面积">
                  <el-input :disabled="true" v-model="dataValForm.basearea"></el-input>
                </el-form-item>
                <el-form-item prop="seweragetype" label="排水户类型">
                  <el-input :disabled="true" v-model="dataValForm.seweragetype"></el-input>
                </el-form-item>
                <el-form-item prop="sewerageindustrytype" label="排水户行业性质">
                  <el-input :disabled="true" v-model="dataValForm.sewerageindustrytype"></el-input>
                </el-form-item>
                <el-form-item prop="contacts" label="联系人">
                  <el-input :disabled="true" v-model="dataValForm.contacts"></el-input>
                </el-form-item>
                <el-form-item prop="contactway" label="联系电话">
                  <el-input :disabled="true" v-model="dataValForm.contactway"></el-input>
                </el-form-item>
                <el-form-item label="项目介绍" prop="introduce" class='textareaform' :inline="false">
                  <el-input :disabled="true" type="textarea" v-model="dataValForm.introduce"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks" class='textareaform' :inline="false">
                  <el-input :disabled="true" type="textarea" v-model="dataValForm.remarks"></el-input>
                </el-form-item>
              </li>
              <li class="form-item">
                <div class="title">现场勘查</div>
                <el-form-item prop="surveypeople" label="勘查人">
                  <el-input :disabled="infFlag" v-model="dataValForm.surveypeople"></el-input>
                </el-form-item>
                <el-form-item prop="surveydate" label="勘查时间">
                  <el-date-picker :disabled="infFlag" v-model="dataValForm.surveydate" type="date"
                                  value-format="yyyy-MM-dd" placeholder="请选择">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="勘查意见" prop="surveyopinion" class='textareaform' :inline="false">
                  <el-input type="textarea" v-model="dataValForm.surveyopinion" :disabled="infFlag"></el-input>
                </el-form-item>
              </li>
              <li class="form-item">
                <div class="title">审核意见</div>
                <el-form-item prop="examinepeople" label="审核人">
                  <el-input v-model="dataValForm.examinepeople" :disabled="infFlag"></el-input>
                </el-form-item>
                <el-form-item prop="examinedate" label="审核时间">
                  <el-date-picker :disabled="infFlag" v-model="dataValForm.examinedate" type="date"
                                  value-format="yyyy-MM-dd" placeholder="请选择">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审核意见" prop="examineopinion" class='textareaform' :inline="false">
                  <el-input :disabled="infFlag" type="textarea" v-model="dataValForm.examineopinion"></el-input>
                </el-form-item>
              </li>
              <li class="form-item">
                <div class="title">批准意见</div>
                <el-form-item prop="approvalpeople" label="批准人">
                  <el-input :disabled="infFlag" v-model="dataValForm.approvalpeople"></el-input>
                </el-form-item>
                <el-form-item prop="approvaldate" label="批准时间">
                  <el-date-picker :disabled="infFlag" v-model="dataValForm.approvaldate" type="date"
                                  value-format="yyyy-MM-dd" placeholder="请选择">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="批准意见" prop="approvalopinion" class='textareaform' :inline="false">
                  <el-input :disabled="infFlag" type="textarea" v-model="dataValForm.approvalopinion"></el-input>
                </el-form-item>
              </li>
              <!-- <li class="form-item">
                <div class="title">许可证信息</div>
                <el-form-item prop="licensenum" label="许可证编号">
                  <el-input :disabled="infFlag" v-model="dataValForm.licensenum"></el-input>
                </el-form-item>
                <el-form-item prop="licensedate" label="发证时间">
                  <el-date-picker :disabled="infFlag" v-model="dataValForm.licensedate" type="date" placeholder="选择申请日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="expirationdate" label="有效期">
                  <el-date-picker :disabled="infFlag" v-model="dataValForm.expirationdate" type="date" placeholder="选择申请日期">
                  </el-date-picker>
                </el-form-item>
              </li> -->
              <div v-show="!infFlag">
                <li class="form-item">
                  <div class="title">内部审批表</div>
                  <div class="pro-table">
                    <el-form-item label="" class="upload">
                      <el-upload class="upload-demo" action="" :limit="5" :on-exceed="handleExceed"
                                 :http-request="uploadProjectFile" :file-list="projectFileList"
                                 :before-remove="beforeRemove">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                      </el-upload>
                    </el-form-item>
                <li class="form-item">
                  <div class="submit">
                    <el-button type="primary" @click="submitForm('dataValForm')">提交</el-button>
                  </div>
                </li>
              </div>
              </li>
      </div>
      <div v-show="infFlag">
        <li class="form-item">
          <div class="title">内部审批表</div>
          <div class="pro-table">
            <el-table :data="projectFileDataList" stripe style="width: 100%" :border='false'
                      :header-cell-style="{background:'#e2e7eb'}">
              <el-table-column prop="num" label="序号" width="60">
              </el-table-column>
              <el-table-column prop="filename" label="文件">
              </el-table-column>
              <el-table-column prop="name" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click='showDialog(scope.row)'>查看</el-button>
                  <el-button type="text" size="small" @click='downFileEvent(scope.row)'>下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </li>
      </div>
      </ul>
      </el-form>
      </el-scrollbar>
    </div>
  </div>
  <!--查看图片弹框-->
  <!--http://192.168.200.148:8091/drainagesystem/fileController/download/1538206390968_drainage.jpg-->
  <!--<el-dialog :visible.sync="dialogVisible" @opened="openedImg()">
    <img id="pic" src="" class="image">
  </el-dialog>-->
  <div class="dialog-container" v-show="dialogVisible" id="dialog-container">
    <div class="dialog-content" id="dialog-content">
      <i class="el-icon-close" @click='dialogVisible=false'></i>
      <img id="pic" src="">
    </div>
  </div>
  <iframe v-show="false" id="iframe1" frameborder=0 name="iframe1" scrolling=auto src=""></iframe>
  </div>
</template>
<script>
export default {
  name: 'FillReport',
  data() {
    var number2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'));
      }
      setTimeout(() => {
        var n2 = /^-?\d+\.?\d{0,2}$/
        if (value < 0) {
          callback(new Error('请输入正数'));
        }
        if (!n2.test(value)) {
          callback(new Error('请输入两位小数数字'));
        } else {
          callback();
        }
      }, 10);
    };
    var percentage = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(' 不能为空'));
      }
      setTimeout(() => {
        var n2 = /^-?\d+\.?\d{0,2}$/
        if (value < 0 || value > 100) {
          callback(new Error('  请输入0-100两位小数数字'));
        } else if (!n2.test(value)) {
          callback(new Error('  请输入两位小数数字'));
        } else {
          callback();
        }
      }, 10);
    };
    var positive = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'));
      }
      setTimeout(() => {
        var pi = /^[1-9]\d*$/;
        if (!pi.test(value)) {
          callback(new Error('请输入正整数'));
        } else {
          callback();
        }
      }, 10);
    };
    return {
      // 上传的文件集合
      uploadFileList: [],
      // 单位文件list
      projectFileList: [],
      infFlag: false,
      fileList: [],
      labelPosition: 'right',
      dataValForm: {},
      id: '',
      projectFileDataList: [],
      rules: {
        //本月处理水量
        monthtreatedwater: [{
          validator: number2,
          trigger: 'blur'
        }],
        //负荷率
        loadrate: [{
          validator: percentage,
          trigger: 'blur'
        }]
      },
      dialogVisible: false,
      //展示图片的路径
      imgPath: ''
    }
  },
  mounted() {

    this.init();
  },
  methods: {
    init() {

      if (this.$route.params.objs) {
        this.dataValForm = this.$route.params.objs;
        //存 入 缓 存
        window.localStorage.removeItem('licenseInfo');
        window.localStorage.setItem('licenseInfo', JSON.stringify(this.$route.params.objs));
      } else {
        this.dataValForm = JSON.parse(window.localStorage.getItem('licenseInfo'));
      }

      if ('edit' == this.dataValForm.infFlag) {
        this.infFlag = false;
        this.handleItemClick1(this.dataValForm.liceid);
      } else {
        this.infFlag = true;
        this.handleItemClick(this.dataValForm.liceid);
      }
      this.timeConvert();
    },
    //日期格式转换
    timeConvert() {
      if (this.dataValForm.surveydate != null)
        this.dataValForm.surveydate = this.time2YMD(this.dataValForm.surveydate.time);
      if (this.dataValForm.examinedate != null)
        this.dataValForm.examinedate = this.time2YMD(this.dataValForm.examinedate.time);
      if (this.dataValForm.approvaldate != null)
        this.dataValForm.approvaldate = this.time2YMD(this.dataValForm.approvaldate.time);
      if (this.dataValForm.licensedate != null)
        this.dataValForm.licensedate = this.time2YMD(this.dataValForm.licensedate.time);
      if (this.dataValForm.expirationdate != null)
        this.dataValForm.expirationdate = this.time2YMD(this.dataValForm.expirationdate.time);
    },
    companyFileOp(row) {
      this.isView = true
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      //				alert(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      this.$message({
        type: 'error',
        message: `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
      });
    },
    //删除图片
    beforeRemove(file, fileList) {
      let that = this;
      $.ajax({
        url: this.basePath + '/fileController/deleteFileByRelationAndFilePath/',
        type: 'POST',
        cache: false,
        data: JSON.stringify({
          relationNum: this.dataValForm.liceid,
          filePath: file.pathName
        }),
        processData: false,
        contentType: false,
        success: function (res) {
          if (res.resCode == 1) {
            //							alert('删除成功')
            that.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        }
      });
    },
    // 上传项目文件
    uploadProjectFile(param) {
      this.publicFileUpload('project', param);
    },
    /**
     * 文件上传公共方法
     * @param  {[type]} fileType [区分单位文件还是项目文件]
     * @param  {[type]} param    [description]
     * @return {[type]}          [description]
     */
    publicFileUpload(fileType, param) {
      var that = this;
      var maxSize = 10 * 1024 * 1024;
      var fileObj = param.file;
      var fileName = fileObj.name;
      var fileSize = fileObj.size;
      var extension = fileName.substring(fileName.lastIndexOf('.'), fileName.length).toLowerCase();
      if ((extension == ".jpg" || extension == ".png") && fileSize < maxSize) {
        var data = new FormData();
        var hz = fileName.substring(fileName.length - 4, fileName.length);
        var filePathName = new Date().getTime() + '_drainage' + hz;
        // 修改上传图片名称
        data.append("file", fileObj, filePathName);
        // 保存文件对象
        // 文件类型用filetype进行区分（）
        // todo
        var fileObj = {
          filepath: filePathName,
          filename: fileName,
          filetype: fileType //文件类型（单位？项目？）
        }
        $.ajax({
          url: this.basePath + '/fileController/upload/single',
          type: 'POST',
          cache: false,
          data: data,
          processData: false,
          contentType: false,
          success: function (res) {
            if (res.resCode == 1) {
              that.uploadFileList.push(fileObj);
            }
          }
        });
      } else {
        //					alert('请选择jpg、png格式，且小于10M的文件');
        this.$message({
          type: 'error',
          message: '请选择jpg、png格式，且小于10M的文件!'
        });
        return;
      }
    },
    // 文件下载
    downFileEvent(row) {
      var path = this.basePath + '/fileController/downloadFile/' + row.filepath;
      document.getElementById('iframe1').setAttribute('src', path);
    },
    //打开图片弹框
    showDialog(row) {
      this.viewPic(row);
      var that = this;
      document.getElementById('pic').setAttribute('src', this.imgPath);
      //				document.getElementById('pic').onload = this.scalingImage(document.getElementById('pic'));
      document.getElementById('pic').onload = function () {  // 打印
        //					that.autoResizeImage(400,400,document.getElementById('pic'));
        //图片宽度
        var picW0 = document.getElementById('pic').naturalWidth;
        //图片高度
        var picH0 = document.getElementById('pic').naturalHeight;

        //当前浏览器窗口宽度
        var winW = document.body.clientWidth;
        //当前浏览器窗口内部高度
        var winH = document.body.clientHeight;
        if (picW0 > 1600 || picH0 > 940) {
          var whObj = that.scalingImage(picW0, picH0, 1600, 940);
          var objWidth = whObj.width;
          var objHeight = whObj.height;
          var widthC = (objWidth - 20) + 'px';
          var heightC = (objHeight - 80) + 'px';
          var picObj = document.getElementById('pic');
          picObj.style.width = widthC;
          picObj.style.height = heightC;
        } else {
          //						var picObj = document.getElementById('pic');
          document.getElementById('pic').style.width = picW0 + 'px';
          document.getElementById('pic').style.height = picH0 + 'px';
        }
        setTimeout(() => {
          var picW = document.getElementById('pic').width;
          var picH = document.getElementById('pic').height;
          //弹框左边距
          var leftW = (winW - picW) / 2;
          //弹框上边距
          var topH = (winH - picH) / 2;
          document.getElementById('dialog-content').style.width = picW + 'px';
          document.getElementById('dialog-content').style.height = picH + 'px';
          document.getElementById('dialog-content').style.left = leftW + 'px';
          document.getElementById('dialog-content').style.top = topH + 'px';
        }, 50);
      };
      this.dialogVisible = true;
      $('#dialog-container').unbind('click').click(function () {
        that.dialogVisible = false;
      });
    },
    //图片缩放
    scalingImage(imgWidth, imgHeight, containerWidth, containerHeight) {
      var containerRatio = containerWidth / containerHeight;
      var imgRatio = imgWidth / imgHeight;

      if (imgRatio > containerRatio) {
        imgWidth = containerWidth;
        imgHeight = containerWidth / imgRatio;
      } else if (imgRatio < containerRatio) {
        imgHeight = containerHeight;
        imgWidth = containerHeight * imgRatio;
      } else {
        imgWidth = containerWidth;
        imgHeight = containerHeight;
      }
      return {
        width: imgWidth,
        height: imgHeight
      };
    },
    //查看图片
    viewPic(row) {
      var iPath = this.basePath + '/fileController/download/' + row.filepath;
      this.imgPath = iPath;
    },
    //  openedImg() {
    //    document.getElementById('pic').setAttribute('src', this.imgPath);
    //  },
    // 获取许可管理详情
    handleItemClick(liceid) {
      this.projectFileDataList = [];
      this.$http.post(this.basePath + '/sewerageUser/getSewerageUserById', {
        //  参数
        liceid: liceid
      }).then((result) => {
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var projectDetail = JSON.parse(result.data.data);
            // 处理文件集合
            if (projectDetail != null && projectDetail.fileList != '') {
              var fileList = JSON.parse(projectDetail.fileList);
              for (var i = 0; i < fileList.length; i++) {
                var dd = fileList[i];
                dd.num = (i + 1);
                this.projectFileDataList.push(dd);
              }
            }
          }
        } else {
          //						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        console.log('获取单位信息异常');
      });
    },
    //编辑页获取附件列表
    handleItemClick1(liceid) {
      this.projectFileList = [];
      this.$http.post(this.basePath + '/sewerageUser/getSewerageUserById', {
        //  参数
        liceid: liceid
      }).then((result) => {
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var projectDetail = JSON.parse(result.data.data);
            // 处理文件集合
            if (projectDetail != null && projectDetail.fileList != '') {
              var fileList = JSON.parse(projectDetail.fileList);
              for (var i = 0; i < fileList.length; i++) {
                var dd = fileList[i];
                var fileUrl = this.basePath + this.fileDownloadPath + dd.filepath;
                this.projectFileList.push({
                  name: dd.filename,
                  url: fileUrl,
                  pathName: dd.filepath
                });
              }
            }
          }
        } else {
          //						alert(result.data.msg)
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
      }, (error) => {
        console.log('获取单位信息异常');
      });
    },
    submitForm(dataValForm) {
      //				debugger;
      this.dataValForm.uploadFileInfor = JSON.stringify(this.uploadFileList);
      this.$refs[dataValForm].validate((valid) => {
        if (valid) {
          var url = this.basePath + '/sewerageUser/saveLicenseDetail';
          this.$http.post(url, this.dataValForm).then((res) => {
            // 响应成功回调
            //							alert("保存成功");
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
            setTimeout(() => {
              this.$router.push({
                name: 'LicenseMain',
                params: {}
              })
            }, 500);
          }, (error) => {
            // 响应错误回调
          })
        } else {
          return false;
        }
      });
    }
  }

}
</script>
<style lang="stylus" scoped>
  .buttons >>> .el-button {
    font-size: 12px;
    border-radius: 2px;
  }

  .submit >>> .el-button {
    font-size: 12px;
    border-radius: 2px;
  }

  .content-wrapper >>> .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .form-item >>> .el-input {
    width: inherit;
    margin: 0 10px;
    font-size: 12px;
    color: #262626;
  }

  .form-item >>> .el-form-item__label {
    font-size: 12px;
    color: #262626;
    padding: 0;
  }

  .form-item >>> .textareaform {
    .el-form-item__label {
      float: left;
    }

    &.el-form-item {
      width: 100%;
    }

    .el-form-item__content {
      width: 80%;
      float: left;

      .el-textarea__inner {
        resize: none;
        height: 100px;
      }
    }
  }

  .form-item >>> .el-form--inline .el-form-item {
    margin-right: 20px;
    margin-bottom: 15px;
  }

  .form-item >>> .el-textarea {
    display: inline-block;
    width: 100%;
    vertical-align: bottom;
    font-size: 12px;
    margin: 0 10px;
  }

  .fill-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    .fill-header {
      height: 60px;
      border-bottom: 1px solid #E2E7EB;
      padding: 0 20px;
      box-sizing: border-box;

      .title {
        font-size: 18px;
        color: #262626;
        float: left;
        line-height: 60px;
      }

      .buttons {
        float: right;
        line-height: 60px;

      }
    }

    .content-wrapper {
      position: absolute;
      top: 80px;
      left: 0;
      bottom: 20px;
      right: 0;
      overflow: hidden;
      box-sizing: border-box;

      .formList {
        padding: 20px;

        .form-item {
          margin-bottom: 15px;

          .water {
            margin-left: 120px;
            margin-bottom: 15px;
            margin-right: 20px;
            float: left;

            span {
              display: inline-block;
              width: 200px;
              font-size: 12px;
              color: #262626;
              letter-spacing: 0;
              text-align: center;
            }
          }

          .submit {
            text-align: center;


          }

          .title {
            font-size: 14px;
            color: #262626;
            margin-bottom: 20px;
            font-weight: 700;
          }

          .item-name,
          .item-unit {
            width: 117px;
            text-align: right;
            font-size: 12px;
            color: #262626;
            letter-spacing: 0;
          }

          .item-unit {
            text-align: left;
          }


          /* .el-textarea__inner {
          resize: none;
        } */
        }
      }
    }
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #ebeef5;
    border-color: #262626;
    color: #000 !important;
    cursor: not-allowed;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #ebeef5;
    border-color: #262626;
    color: #000 !important;
    cursor: not-allowed;
  }

  .pro-table {
    margin: 0 20px;

    .el-table td,
    .el-table th {
      padding: 6px 0;
    }

    .el-table thead.is-group th {
      background: #fafafa;
    }

    .el-table td {
      border: none;
    }

    .el-table .cell {
      font-size: 12px;
      /*color: #262626;*/
    }

    .el-table thead {
      font-size: 12px;
    }

    .data-wrapper .table-wrapper .el-table .cell {
      color: #666;
    }

    .el-table th {
      background-color: #FAFAFA;
      border-right: 1px solid #ffffff;

      &:last-child {
        border-right: none;
      }
    }
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: oldlace !important;
  }

  .dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;

    .dialog-content {
      position: absolute;
      width: auto;
      height: auto;
      min-height: 100px;
      max-height: 940px;
      min-width: 100px;
      max-width: 1600px;
      top: 50px;
      left: 50px;
      background-color: #fff;
      overflow: hidden;

      img {
        width: auto;
        height: auto;
        /*margin: 41px 10px 10px 10px;*/
      }

      /*关闭按钮*/

      i {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/license/components/licenseInfo.vue